module.exports = __webpack_public_path__ + "img/ic_32_sport_eishockey-active.5c092d2f.svg";